import { releaseNotificationConstants } from "../actions/constants/releaseNotificationConstant";

const releaseNotificationData = (
	state = { status: "", message: "" },
	action: any
) => {
	switch (action.type) {
		// Existing settings loaded when the page is opened
		case releaseNotificationConstants.ReleaseNotificationSettingGetRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isDetailComplete: false,
			};
		case releaseNotificationConstants.ReleaseNotificationSettingGetSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailError: false,
				isDetailComplete: true,
				settingInput: action.payload,
			};
		case releaseNotificationConstants.ReleaseNotificationSettingGetFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case releaseNotificationConstants.ReleaseNotificationSettingUpdateRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				isUpdateComplete: false,
			};
		case releaseNotificationConstants.ReleaseNotificationSettingUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				isUpdateComplete: true,
				status: action.payload?.status,
			};
		case releaseNotificationConstants.ReleaseNotificationSettingUpdateFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				isUpdateComplete: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default releaseNotificationData;
